import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventRequestModalComponent } from '../../../../routed-pages/events/components/event-request-modal/event-request-modal.component';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent implements OnInit {

  @Input('modalTitle') modalTitle: string;
  @Input('showConfirmButton') showConfirmButton: boolean = false;
  @Input('confirmButtonLabel') confirmButtonLabel: string;
  @Input('cancelButtonLabel') cancelButtonLabel: string = "Close";
  @Output() onConfirm = new EventEmitter();

  @ViewChild('confirmationModal', { static: false }) private modalContent: TemplateRef<ConfirmationModalComponent>;
  private modalRef: NgbModalRef;

  constructor(
    private modalService: NgbModal) { }

  ngOnInit() {
  }

  open() {
    this.modalRef = this.modalService.open(this.modalContent, { ariaLabelledBy: 'modal-basic-title', size: 'lg' });
  }

  confirm(event: Event) {
    this.onConfirm.emit(event);
  }
}
